import { atom } from "jotai";
import { edgesAtom } from "./edgesAtom";

export const selectedEdgesAtom = atom((get) =>
  get(edgesAtom).filter((edge) => edge.selected),
);

selectedEdgesAtom.debugLabel = "selectedEdgesAtom";
